'use client';

import { useTranslations } from 'next-intl';
import DarkMysticalDivider from '@/components/dashboard/DarkMysticalDivider';

export default function OracleInterpretation({ upright, reversed }) {
  const t = useTranslations('tarot.card.interpretation');

  return (
    <div className="my-8">
      {/* Upright Interpretation */}
      <h2 className="text-sm uppercase tracking-[0.3em] text-[#D4B6FF]/70 mb-3" style={{ fontFamily: "var(--font-marcellus)" }}>
        {t('upright')}
      </h2>
      <h3 className="text-3xl md:text-4xl font-bold text-white mb-4 md:mb-6" style={{ fontFamily: "var(--font-marcellus)" }}>
        {upright.title}
      </h3>
      <div className="space-y-4 text-gray-300 text-lg leading-relaxed">
        {upright.meaning.split('\n\n').map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}
      </div>

      <div className="my-6 p-4 bg-[#1f1d33] border-l-4 border-[#A45DE8] rounded-r-lg shadow-inner">
        <h4 className="inline-block text-purple-400 text-sm font-semibold tracking-wider uppercase mb-2" style={{ fontFamily: "var(--font-marcellus)" }}>{t('guidance')}</h4>
        <p className="italic text-gray-300">{upright.reflectionPrompt}</p>
      </div>

      <div className="my-6">
        <h4 className="font-semibold text-xl text-[#D4B6FF] mb-2" style={{ fontFamily: "var(--font-marcellus)" }}>{t('insight')}</h4>
        <p className="text-gray-300">{upright.insight}</p>
      </div>

      <DarkMysticalDivider className="my-8" />

      <div className="mt-8">
        <h2 className="text-sm uppercase tracking-[0.3em] text-[#D4B6FF]/70 mb-3" style={{ fontFamily: "var(--font-marcellus)" }}>
          {t('reversed')}
        </h2>
        <h3 className="text-3xl md:text-4xl font-bold text-white mb-4 md:mb-6" style={{ fontFamily: "var(--font-marcellus)" }}>{reversed.title}</h3>
        <div className="space-y-4 text-gray-300 text-lg leading-relaxed">
          {reversed.meaning.split('\n\n').map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </div>

        <div className="my-6 p-4 bg-[#1f1d33] border-l-4 border-[#A45DE8] rounded-r-lg shadow-inner">
          <h4 className="inline-block text-purple-400 text-sm font-semibold tracking-wider uppercase mb-2" style={{ fontFamily: "var(--font-marcellus)" }}>{t('counsel')}</h4>
          <p className="italic text-gray-300">{reversed.practicalAdvice}</p>
        </div>

        <div className="my-6">
          <h4 className="font-semibold text-xl text-[#D4B6FF] mb-2" style={{ fontFamily: "var(--font-marcellus)" }}>{t('insight')}</h4>
          <p className="text-gray-300">{reversed.insight}</p>
        </div>
      </div>
    </div>
  );
} 